import React, { useState } from 'react';
import {defaultStatusColumns, SEColumns, shouldDisable} from './status.utils';
import IpsDTCommentsIcon from 'components/CommentsIcon/IpsDTCommentsIcon';
import StatusTable from './statusTable/index.js';
import { Col, Checkbox, Row } from 'antd';
import CommentBox from './DailogBox';

function ControlCircuitsView(props) {
  const {
    project,
   
    handleProjectDetailUpdate,
    comments,
    isReadOnly,
    phaseDetails,
    phaseId,
    isProjectOnHold
  } = props;
  // const { ipsProjectDetails } = projectDetails || {};
  const [controlCircuitsDropdownOption, setControlCircuitsDropDownOptions] =
    useState(['QA Feedback', 'Completed']);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCommentDialogueSubmit = (comment) => {
    // we are combining Flag + comment so we don't have to make  two calls

    handleProjectDetailUpdate(`N-${comment}`, 'CTRL_CIRCUIT_FLAG', 'string',phaseId);

    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const controlCircuitsHandler = (e) => {
    let value = e.target.checked ? 'N' : 'Y';

    if (e.target.checked) {
      setIsModalOpen(true);
    } else {
      handleProjectDetailUpdate(value, 'CTRL_CIRCUIT_FLAG', 'string',phaseId);
    }
  };

  return (
    <>
      <div>
        <section className='padding-container'>
          <div>
            <IpsDTCommentsIcon
              project={project}
              comments={comments}
              commentGroup={'CTRL'}
              phase={phaseId}

            />
          </div>
          <Row>
            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 24,
              }}
              lg={{
                span: 12,
              }}
              xxl={{
                span: 12,
              }}
            >
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  Control Circuits
                </Col>
                <Col>
                  <Checkbox
                    onChange={controlCircuitsHandler}
                    defaultChecked={false}
                    checked={phaseDetails?.ctrlCircuitFlag === 'N'}
                    style={{
                      display: 'flex',
                      border: 'none',
                      padding: 0,
                      margin: 0,
                    }}
                    disabled={isReadOnly||isProjectOnHold}
                  />
                </Col>
                <Col
                  style={{ marginLeft: '5px' }}
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  N/A
                </Col>
                <CommentBox
                  show={isModalOpen}
                  handleCommentDialogueSubmit={handleCommentDialogueSubmit}
                  name={'Control Circuits'}
                  handleCancel={handleCancel}
                />
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  {''}
                </Col>
                {phaseDetails &&
                  phaseDetails.ctrlCircuitChangedDate && (
                    <Col>{`${phaseDetails.ctrlCircuitChangedUser}  ${phaseDetails.ctrlCircuitChangedDate}`}</Col>
                  )}
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  {''}
                </Col>
                {phaseDetails &&
                  phaseDetails.ctrlCircuitChangedDate &&
                  phaseDetails.ctrlCircuitComments &&
                  (
                    <Col>{`${phaseDetails.ctrlCircuitComments}`}</Col>
                  )}
              </Row>
            </Col>
          </Row>

          <StatusTable
            dataSource={phaseDetails?.ctrlCircuitHistory}
            dropOptions={controlCircuitsDropdownOption}
            disabledButtons={
              isReadOnly ||isProjectOnHold||
              phaseDetails?.ctrlCircuitFlag === 'N' ||
              shouldDisable(
                phaseDetails?.ctrlCircuitStatus === 'Completed'
              )
            }
            fieldName = {'CTRL_CIRCUIT_STATUS'}
            currentStatus = {phaseDetails.ctrlCircuitStatus}
            phaseId = {phaseId}
            handleProjectDetailUpdate = {handleProjectDetailUpdate}
            disableDelete = {project.trackerStatus === 'DT_C' ? true : false}
          />
        </section>
      </div>
    </>
  );
}
export default ControlCircuitsView;
